import { render } from "./DevolucaoComprasIndex.vue?vue&type=template&id=872a9ef8&ts=true"
import script from "./DevolucaoComprasIndex.vue?vue&type=script&lang=ts"
export * from "./DevolucaoComprasIndex.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\Desenvolvimento\\NeoXFront\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__